import { render, staticRenderFns } from "./taskOtherOrder.vue?vue&type=template&id=d68d5d50&"
import script from "./taskOtherOrder.vue?vue&type=script&lang=js&"
export * from "./taskOtherOrder.vue?vue&type=script&lang=js&"
import style0 from "./taskOtherOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports